import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getNakaLaData = createAsyncThunk("api/nakal-kafala", async (token) => {
    try {
        const response = await nodeinstance.get("/nakal-kafala", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const NakalaDataSlice = createSlice({
    name: "nakal-kafala",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getNakaLaData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getNakaLaData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getNakaLaData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getNakaLaData };
export default NakalaDataSlice.reducer;
